var _rect, _path, _rect2, _rect3, _path2, _circle, _path3, _circle2, _path4, _circle3, _rect4, _circle4, _path5, _rect5, _rect6, _rect7, _path6, _rect8, _rect9, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatPromo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 340 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 34,
    width: 208,
    height: 178,
    rx: 16,
    fill: "#F4F6FA",
    stroke: "#ECEEF2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 96h208 M26 150h208 M92 34v178 M160 34v178",
    stroke: "#E6EAF1",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 108,
    width: 40,
    height: 32,
    rx: 10,
    fill: "#E4F0E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 50,
    width: 50,
    height: 34,
    rx: 12,
    fill: "#E2ECF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70c0-7 5.5-12 12-12s12 5 12 12c0 9-12 20-12 20s-12-11-12-20z",
    fill: "#FBDFA8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 70,
    r: 5,
    fill: "#F59E0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 150c0-6 4.5-10 10-10s10 4 10 10c0 7.5-10 17-10 17s-10-9.5-10-17z",
    fill: "#FBDFA8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 150,
    r: 4.2,
    fill: "#F59E0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112 116c0-9 7-15.5 15.5-15.5S143 107 143 116c0 12-15.5 25-15.5 25S112 128 112 116z",
    fill: "#F59E0B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 115,
    r: 6.5,
    fill: "#FFFFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 40,
    width: 176,
    height: 32,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#ECEEF2",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 56,
    r: 7,
    fill: "none",
    stroke: "#F59E0B",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145 61l5 5",
    stroke: "#F59E0B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 53,
    width: 100,
    height: 6,
    rx: 3,
    fill: "#E5E8EE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 120,
    width: 148,
    height: 96,
    rx: 14,
    fill: "#FFFFFF",
    stroke: "#ECEEF2",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 134,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#FEF1DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188 178l10-12 7 8 6-5 13 9z",
    fill: "#FBD79A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 138,
    width: 62,
    height: 8,
    rx: 4,
    fill: "#E5E8EE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 152,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#EEF1F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M240 172l1.6 3.3 3.6.5-2.6 2.5.6 3.6-3.2-1.7-3.2 1.7.6-3.6-2.6-2.5 3.6-.5z",
    fill: "#F59E0B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M258 172l1.6 3.3 3.6.5-2.6 2.5.6 3.6-3.2-1.7-3.2 1.7.6-3.6-2.6-2.5 3.6-.5z",
    fill: "#F59E0B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276 172l1.6 3.3 3.6.5-2.6 2.5.6 3.6-3.2-1.7-3.2 1.7.6-3.6-2.6-2.5 3.6-.5z",
    fill: "#F59E0B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M294 172l1.6 3.3 3.6.5-2.6 2.5.6 3.6-3.2-1.7-3.2 1.7.6-3.6-2.6-2.5 3.6-.5z",
    fill: "#F59E0B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M312 172l1.6 3.3 3.6.5-2.6 2.5.6 3.6-3.2-1.7-3.2 1.7.6-3.6-2.6-2.5 3.6-.5z",
    fill: "#FBDFA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatPromo);
export default __webpack_public_path__ + "static/media/feat-promo.691565fbcb23ba712c3e2271a0ca618a.svg";
export { ForwardRef as ReactComponent };